import React from "react";
import Grid from "@material-ui/core/Grid";

import Section from "../../../components/ui/Section.jsx";
import InfoCard from "../../../components/ui/InfoCard.jsx";
import { services } from "../assets";

// Unlinked from `material-kit-pro-react`: built from our own brand-themed UI
// primitives + MUI v3 Grid, driven by the services data.
function SectionServices() {
  return (
    <Section>
      <Grid container spacing={32} justify="center">
        {services.map(service => (
          <Grid item xs={12} sm={6} md={4} key={service.title}>
            <InfoCard
              icon={service.icon}
              title={service.title}
              description={service.description}
            />
          </Grid>
        ))}
      </Grid>
    </Section>
  );
}

export default SectionServices;



// WEBPACK FOOTER //
// ./src/views/AboutUsPage/Sections/SectionServices.jsx